// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rightsholder-maintenance-banking-tab iframe {
  width: 100%;
  margin-top: 4.8rem;
}
.rightsholder-maintenance-banking-tab .bubble-block {
  margin-top: 1rem;
  margin-left: 23rem;
}
.rightsholder-maintenance-banking-tab p {
  padding-top: 5rem;
  display: flex;
  flex-direction: column;
  width: 50%;
}
.rightsholder-maintenance-banking-tab p a {
  width: 5%;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/RightsholderScene/RightsholderMaintenance/RightsholderMaintenanceBankingTab/TipaltiIFrame/index.scss"],"names":[],"mappings":"AACE;EACE,WAAA;EACA,kBAAA;AAAJ;AAGE;EACE,gBAAA;EACA,kBAAA;AADJ;AAIE;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;AAFJ;AAII;EACE,SAAA;AAFN","sourcesContent":[".rightsholder-maintenance-banking-tab {\n  iframe {\n    width: 100%;\n    margin-top: 4.8rem;\n  }\n\n  .bubble-block {\n    margin-top: 1rem;\n    margin-left: 23rem;\n  }\n\n  p {\n    padding-top: 5rem;\n    display: flex;\n    flex-direction: column;\n    width: 50%;\n\n    a {\n      width: 5%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
